module.exports = __webpack_public_path__ + "static/assets/17dc5cb719eb873ad080b50f94bdba73.svg";